import { StateNode, TLPointerEventInfo } from "@tldraw/tldraw";

export class Idle extends StateNode {
  static override id = "idle";

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("drawing", info);
  }

  override onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }

  override onCancel() {
    this.editor.setCurrentTool("select");
  }
}
